module.exports = __webpack_public_path__ + "static/media/de-angelo.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/designer-profiles/de-angelo.png
// module id = 521
// module chunks = 0